/*
 * The browser's own fetch, captured before src/store.js replaces window.fetch.
 *
 * store.js wraps window.fetch and adds `Authorization: Bearer <token>` to every
 * request it does not skip, whatever the host. A phone sign-up stores the
 * session token on the /login page and stays there for the profile step, so on
 * a page that records (M2, consented Hotjar) a recorder that sends through
 * window.fetch would carry the session token to its own servers. The sealed
 * page (replay-document.js) sends the recorder's own fetches through this
 * captured function instead, so they never pass through that wrapper.
 *
 * This module must be evaluated before store.js: src/index.js imports it first
 * (pinned by replay-document.test.js).
 */
const captured = typeof window !== "undefined" && typeof window.fetch === "function"
  ? window.fetch
  : null;

export const getPristineFetch = () => captured;
